
import { defineComponent } from "vue";
import { Input, Button, message } from "ant-design-vue";
import DragCard from "@/components/channel/DragCard.vue";
import DragCard2 from "@/components/channel/DragCard2.vue";
import DragCard3 from "@/components/channel/DragCard3.vue";
import DragCard4 from "@/components/channel/DragCard4.vue";
import DragCardSubChannel from "@/components/channel/DragCardSubChannel.vue";

export default defineComponent({
  components: {
    Image,
    Button,
    DragCard,
    DragCard2,
    DragCard3,
    DragCard4,
    DragCardSubChannel,
  },
  data() {
    return {};
  },
  methods: {
    myEvent() {
      (this as any).$refs.items1.getList();
    },
  },
  watch: {},
  mounted() {},
  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
});
